import { Container, SxProps, Theme } from "@mui/material"
import { useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from "src/components";
import { helper } from "src/utils/helper";
import Popover from "src/components/Popover";
import kullaniciService from "src/services/Settings/Generals/kullanici.service";
import { useConfirmation } from "src/base/ConfirmationDialog/ConfirmationService";
import { useAppSelector } from "src/store";
import { translate } from "src/i18n/tHelper";
interface RecordInfoProps {
    id: string | number,
    ekleyenKullanici?: number;
    eklemeTarihi?: string;
    guncelleyenKullanici?: number;
    guncellemeTarihi?: string;
    iptalKullanici?: number;
    iptalTarihi?: string;
    iptalNedenGrupId?: number;
    iptalNedenId?: number;
    onayTarihi?: string;
    onayKullanici?: number;
    children?: any;
}
const translatePath = "component|recordInfo";
const RecordInfo = (props: RecordInfoProps): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState(null);
    const parametre = useAppSelector(s => s.parameters.data);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'record-popover' : undefined;

    const typographySx: SxProps<Theme> = {
        fontWeight: 400,
        color: "#fff"
    }

    const [ekleyenKullaniciAd, setEkleyenKullaniciAd] = useState("");
    const [guncelleyenKullaniciAd, setGuncelleyenKullaniciAd] = useState("");
    const [iptalKullaniciAd, setIptalKullaniciAd] = useState("");
    const [onayKullaniciAd, setOnayKullaniciAd] = useState("");
    const [iptalNedenAd, setIptalNedenAd] = useState("")

    const confirm = useConfirmation();
    return (
        <>
            <InfoIcon sx={{ height: '2em' }} color={"primary"} onClick={(e) => {
                setAnchorEl(e.currentTarget);
                setEkleyenKullaniciAd("")
                setGuncelleyenKullaniciAd("")
                setIptalKullaniciAd("")
                if (props.ekleyenKullanici > 0) {
                    kullaniciService.getOne(props.ekleyenKullanici)
                        .then(res => {
                            if (res.responseCode != 200) {
                                confirm({
                                    description: res.errorMessage,
                                    title: "",
                                    variant: "info"
                                })
                                return;
                            }
                            setEkleyenKullaniciAd(res.data.adi + " " + res.data.soyadi);
                        })
                }
                if (props.guncelleyenKullanici > 0) {
                    kullaniciService.getOne(props.guncelleyenKullanici)
                        .then(res => {
                            if (res.responseCode != 200) {
                                confirm({
                                    description: res.errorMessage,
                                    title: "",
                                    variant: "info"
                                })
                                return;
                            }
                            setGuncelleyenKullaniciAd(res.data.adi + " " + res.data.soyadi);
                        })
                }
                if (props.iptalKullanici > 0) {
                    kullaniciService.getOne(props.iptalKullanici)
                        .then(res => {
                            if (res.responseCode != 200) {
                                confirm({
                                    description: res.errorMessage,
                                    title: "",
                                    variant: "info"
                                })
                                return;
                            }
                            setIptalKullaniciAd(res.data.adi + " " + res.data.soyadi);
                        })
                }
                if (props.onayKullanici > 0) {
                    kullaniciService.getOne(props.onayKullanici)
                        .then(res => {
                            if (res.responseCode != 200) {
                                confirm({
                                    description: res.errorMessage,
                                    title: "",
                                    variant: "info"
                                })
                                return;
                            }
                            setOnayKullaniciAd(res.data.adi + " " + res.data.soyadi);
                        })
                }
                if (props.iptalNedenId > 0) {
                    const bul = parametre?.filter((f) => f.grupId === props?.iptalNedenGrupId)?.find((f) => f.key === props?.iptalNedenId)
                    setIptalNedenAd(bul.value);
                }
            }} />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Container sx={{
                    p: 2,
                    backgroundColor: "rgba(97, 97, 97, 0.92)"

                }}>
                    {props.id &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Kayıt No") + ": " + props.id}
                        </Typography>
                    }
                    {ekleyenKullaniciAd &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Ekleyen Kullanıcı: ") + ": " + ekleyenKullaniciAd}
                        </Typography>
                    }
                    {props.eklemeTarihi &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Ekleme Tarihi") + ": " +
                                (helper.jsonToLongDateString(props.eklemeTarihi))
                            }
                        </Typography>
                    }
                    {guncelleyenKullaniciAd &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Güncelleyen Kullanıcı") + ": " + guncelleyenKullaniciAd}
                        </Typography>
                    }
                    {props.guncellemeTarihi &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Güncelleme Tarihi") + ": " +
                                (helper.jsonToLongDateString(props.guncellemeTarihi))
                            }
                        </Typography>
                    }
                    {iptalKullaniciAd &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "İptal Eden Kullanıcı") + ": " + iptalKullaniciAd}
                        </Typography>
                    }
                    {props.iptalTarihi &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "İptal Tarihi") + ": " +
                                (helper.jsonToLongDateString(props.iptalTarihi))
                            }
                        </Typography>
                    }
                    {iptalNedenAd &&
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "İptal Nedeni") + ": " + iptalNedenAd}
                        </Typography>
                    }
                    {onayKullaniciAd && (
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Onay Kullanıcı") + ": " + iptalKullaniciAd}
                        </Typography>
                    )}
                    {props.onayTarihi && (
                        <Typography sx={typographySx} variant={"subtitle2"}>
                            {translate(translatePath, "Onay Tarihi") + ": " +
                                (helper.jsonToLongDateString(props.iptalTarihi))
                            }
                        </Typography>
                    )}
                </Container>
            </Popover>
        </>
    )
}
export default RecordInfo; 